import { authFetch } from "../helpers/FetchHelpers";
const { default: DataService } = require("./DataService");

class EmployeeDataService extends DataService {
    constructor() {
        super("employee")
    }

    upload(fileLocation) {
        const formData = new FormData();
        formData.append('csv_data', fileLocation);

        return fetch(process.env.REACT_APP_API_URL + '/user/employee', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_auth_token'),
            },
            body: formData,
        })
        .then((res) => {
            if (res.status === 700) {
                localStorage.clear();
                return { data: {
                    needRelogin: true,
                    errorMessage: 'Sesi berakhir. Tolong logout atau refresh untuk logout.',
                }};
            } else if (res.status > 200) {
                return { data: {
                    errorMessage: 'Internal server error',
                }};
            }
            return res.json()
        })
    }

    getByNIK(nik) {
        return authFetch(process.env.REACT_APP_API_URL + '/user/employee?nik=' + nik, 'GET', null);
    }
}

export default EmployeeDataService;